	$(function() {

      // 轮播图1
      var swiper1 = new Swiper('.swiper-banner', {
        // effect : 'fade',
        //动画
        loop: true, 
        speed: 2000,
        pagination: {
            el: '.swiper-banner-pagination',
        },
        slidesPerView: 1,
        // centeredSlides: true,
        spaceBetween: 0,
        autoplay: {
          delay: 5000,
        },
    });


    var index=0
    setBox()
    $('.pagination-item .page-item').hover(function() {
      index=$(this).index()
      setBox()
    })


  function setBox () {
    $('.pagination-item .page-item').removeClass('actives wow fadeInUp')
    $('.pagination-item .page-item').eq(index).addClass('actives wow fadeInUp')

    $('.swiper-item .item').removeClass('active wow fadeInUp')
    $('.swiper-item .item').eq(index).addClass('active wow fadeInUp')
  }




	    $(".content .banner .mouse").click(function() {
	        $('html, body').animate({
	            scrollTop: $(".skill-content").offset().top - $("header").height()
	        });
	    });


     


	    // banner视频逻辑
	    $(".video video").trigger('pause');
	    $(".play-video").click(function() {
	        $(".video").fadeIn();
	        $(".video video").trigger('play');
	    });

	    $(".video .shadow, .video .video-parent .iconfont").click(function() {
	        $(".video").hide();
	        $(".video video").trigger('pause');
	    });

	    // 小屏幕视频不播放
	    if ($(window).width() <= 768) {
	        // $(".banner video").trigger('pause');
	    };








	    if ("Microsoft Internet Explorer" == navigator.appName && parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE", "")) < 10) {
	        var slide = $(".swiper-kv .swiper-slide");
	        $(".swiper-pagination,.swiper-button-prev,.swiper-button-next").hide();
	        for (var i = 0; i < slide.length; i++) i > 0 && $(slide[i]).hide()
	    } else {




	        var swipers = {};
	        $(".swiper-container-item").each(function(index) {
	            var name = index + 1;
	            swipers['swiper' + name] = new Swiper('.swiper' + name, {
	                on: {
	                    slideChangeTransitionStart: function() {

	                    },
	                },
	                // 如果需要前进后退按钮
	                navigation: {
	                    // nextEl: '.swiper-button-next' + name,
	                    // prevEl: '.swiper-button-prev' + name,
	                },
	                pagination: {
	                    el: '.swiper-pagination' + name,
	                    type: 'bullets',
	                    clickable: true,
	                },
	                observer: true,
	                observerParents: true,
	                loop: true,
	                speed: 2000,

	                // 自动播放
	                autoplay: {
	                    delay: 5000,
	                    stopOnLastSlide: false,
	                    // 当设置为false时，用户操作之后autoplay不会被禁掉
	                    disableOnInteraction: false,
	                },

	            });
	        });






	        function swiperFun() {
	            var swiperss = {};
	            $(".swiper-container-itemss").each(function(index) {
	                var name = index + 1;
	                swiperss['swiperss' + name] = new Swiper('.swiperss' + name, {
	                    on: {
	                        slideChangeTransitionStart: function() {

	                        },
	                    },
	                    // 如果需要前进后退按钮
	                    navigation: {
	                        nextEl: '.swiper-button-nextss' + name,
	                        prevEl: '.swiper-button-prevss' + name,
	                    },
	                    // pagination: {
	                    //     el: '.swiper-paginationss' + name,
	                    //     type: 'bullets',
	                    //     clickable :true,
	                    // },
	                    observer: true,
	                    observerParents: true,
	                    loop: true,
	                    speed: 1000,

	                    // 自动播放
	                    autoplay: {
	                        delay: 2500,
	                        stopOnLastSlide: false,
	                        // 当设置为false时，用户操作之后autoplay不会被禁掉
	                        disableOnInteraction: false,
	                    },

	                });
	            });
	        };

	        swiperFun();







	    };






	    // tab切换
	    $(".tab1 .tab-tit .item").click(function() {
	        var index = $(this).index();
	        var tab = $(this).parents(".tab1");
	        $(this).addClass("active").siblings().removeClass("active");
	        tab.find(".tab-con .item").find(".img").removeClass("active animated fadeInLeft");
	        tab.find(".tab-con .item").eq(index).find(".img").addClass("active animated fadeInLeft");
	        tab.find(".tab-con .item").find(".swiper-container-item").removeClass("active animated fadeInRight");
	        tab.find(".tab-con .item").eq(index).find(".swiper-container-item").addClass("active animated fadeInRight");
	        tab.find(".tab-con .item").find(".swiper-pagination").removeClass("active");
	        tab.find(".tab-con .item").eq(index).find(".swiper-pagination").addClass("active");
	    });



	    $(".tab2 .tab-tit .item").click(function() {
	        var index = $(this).index();
	        var tab = $(this).parents(".tab2");
	        $(this).addClass("active").siblings().removeClass("active");
	        tab.find(".tab-con .item").find(".swiper-container-itemss").removeClass("active animated fadeInUp");
	        tab.find(".tab-con .item").eq(index).find(".swiper-container-itemss").addClass("active animated fadeInUp");
	        tab.find(".tab-con .item").find(".introduct").removeClass("active animated fadeInUp");
	        tab.find(".tab-con .item").eq(index).find(".introduct").addClass("active animated fadeInUp");
	        swiperFun();

	    });


	    $(".content .advantage .advantage-con .item").hover(function() {
	        $(this).find(".text2").stop().slideDown();
	    }, function() {
	        $(this).find(".text2").stop().slideUp();
	    })










	})